<template>
  <div id="list">
    <general-form-list-component
      :get-items-function="getItems"
      :delete-item-function="deleteItem"
      :create-item-function="createItem"
      form-name="general_skaly_po"
    />
  </div>
</template>


<script>
import { APIService } from "@/http/APIService.js";
const apiService = new APIService();

import GeneralFormListComponent from './GeneralFormListComponent.vue';

export default {
  components: {
    "general-form-list-component": GeneralFormListComponent,
  },
  data: () => ({
  }),

  methods: {
    getItems(
      sort,
      search,
      limit,
      offset,
      filter_key,
      filter_value
    ) {
      return apiService.getGeneralSkalyPoForms(
        sort,
        search,
        limit,
        offset,
        filter_key,
        filter_value
      );
    },
    deleteItem(item) {
      return apiService.deleteGeneralSkalyPo(item);
    },

    createItem(item) {
      return apiService.createGeneralSkalyPo(item);
    },
  },
};
</script>